<template>
  <div
    class="layout layout--fullbleed"
    data-test-id="fullbleed-layout"
  >
    <div
      v-if="showLeaderboardAd"
      class="layout__leaderboard-container"
      :class="{ 'layout__leaderboard-container--has-color-header' : colorHeaderBackground }"
      data-test-id="layout-leaderboard-container"
      :style="{ backgroundColor: colorHeaderBackground }"
    >
      <ad-slot mapping="leaderboard" />
    </div>
    <slot name="hero" />
    <div
      id="layout-content"
      class="layout__content"
      data-test-id="layout-content"
    >
      <not-found v-if="is404" />
      <slot v-else />
    </div>
  </div>
</template>

<script>
import AdSlot from '@/components/Ads/AdSlot.vue';
import NotFound from '@/components/Global/NotFound.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'FullBleedLayout',
  components: {
    AdSlot,
    NotFound,
  },
  props: {
    showLeaderboardAd: {
      type: Boolean,
      default: false,
    },
    colorHeaderBackground: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters(['is404']),
  },
};
</script>
